import React, { useState, useEffect, ChangeEvent } from 'react'; // CORREÇÃO: Adicionar ChangeEvent
import { useNavigate, Link } from 'react-router-dom';
import { authService } from '../services/authService';
import trackingService from '../services/trackingService';

export default function Login() {
  const navigate = useNavigate();
  const [empresa, setEmpresa] = useState('');
  const [usuario, setUsuario] = useState('');
  const [senha, setSenha] = useState('');
  const [carregando, setCarregando] = useState(false);
  const [erro, setErro] = useState('');

  // Verificar se o usuário já está autenticado e redirecionar para dashboard
  useEffect(() => {
    if (authService.isAuthenticated()) {
      console.log('[LOGIN] Usuário já está autenticado. Redirecionando para dashboard...');
      navigate('/dashboard');
    }
  }, [navigate]);

  // Versão com autenticação real - MELHORADA
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setCarregando(true);
    setErro(''); // Limpar erro anterior
    
    try {
      console.log(`[LOGIN] Tentando autenticar: Empresa="${empresa}", Usuário="${usuario}"`);
      
      // Autenticar com authService, passando as credenciais
      const loginSucesso = await authService.login(empresa, usuario, senha);
      
      if (loginSucesso) {
        console.log('[LOGIN] Login realizado com sucesso!');
        // Rastrear login bem-sucedido
        trackingService.trackLogin('credentials');
        // Redirecionar para o dashboard
        navigate('/dashboard');
      } else {
        console.log('[LOGIN] Login falhou - credenciais inválidas');
        setErro('Credenciais inválidas. Verifique empresa, usuário e senha.');
      }
    } catch (error: any) {
      console.error('[LOGIN] Erro ao processar login:', error);
      
      // Tratamento de erro mais específico
      if (error.response?.status === 401) {
        setErro('Credenciais inválidas. Verifique empresa, usuário e senha.');
      } else if (error.response?.status === 503) {
        setErro('Serviço temporariamente indisponível. Tente novamente em alguns minutos.');
      } else if (error.code === 'NETWORK_ERROR' || error.message?.includes('Network Error')) {
        setErro('Erro de conexão. Verifique sua internet e tente novamente.');
      } else {
        setErro('Erro inesperado ao processar login. Tente novamente.');
      }
    } finally {
      setCarregando(false);
    }
  };
  
  return (
    <div className="login-page">
      <div className="login-box">
        <div className="card">
          <div className="card-header text-center">
            <img src="/img/logo-principal.png" alt="Logo" style={{ height: '60px', marginBottom: '10px' }} />
          </div>
          <div className="card-body login-card-body">
            <p className="login-box-msg">Faça login para iniciar sua sessão</p>
            
            {erro && (
              <div className="alert alert-danger" role="alert">
                {erro}
              </div>
            )}
            
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <div className="input-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Nome da Empresa/Clínica"
                    value={empresa}
                    onChange={(e: ChangeEvent<HTMLInputElement>) => setEmpresa(e.target.value)}
                    required
                  />
                  <div className="input-group-append">
                    <div className="input-group-text">
                      <i className="fas fa-building"></i>
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="mb-3">
                <div className="input-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Usuário"
                    value={usuario}
                    onChange={(e: ChangeEvent<HTMLInputElement>) => setUsuario(e.target.value)}
                    required
                  />
                  <div className="input-group-append">
                    <div className="input-group-text">
                      <i className="fas fa-user"></i>
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="mb-3">
                <div className="input-group">
                  <input
                    type="password"
                    className="form-control"
                    placeholder="Senha"
                    value={senha}
                    onChange={(e: ChangeEvent<HTMLInputElement>) => setSenha(e.target.value)}
                    required
                  />
                  <div className="input-group-append">
                    <div className="input-group-text">
                      <i className="fas fa-lock"></i>
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="row">
                <div className="col-8">
                  <div className="icheck-primary">
                    <input type="checkbox" id="remember" />
                    <label htmlFor="remember" className="ms-2">
                      Lembrar-me
                    </label>
                  </div>
                </div>
                <div className="col-4">
                  <button 
                    type="submit" 
                    className="btn btn-primary btn-block" 
                    disabled={carregando}
                  >
                    {carregando ? (
                      <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    ) : 'Entrar'}
                  </button>
                </div>
              </div>
            </form>
            
            <div className="mt-3 text-center">
              <p className="mb-1">
                <Link to="/forgot-password" className="text-decoration-none">
                  Esqueci minha senha
                </Link>
              </p>
              
              <div className="text-center mt-3">
                <p>
                  Ainda não tem uma conta?{' '}
                  <Link to="/cadastro" className="text-primary fw-bold">
                    Cadastre-se
                  </Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
